// src/pages/PrintTest.jsx
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

export default function PrintTest() {
  const contentRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef, // v3 API
    documentTitle: "PrintTest",
  });

  return (
    <div className="p-8">
      <div ref={contentRef} className="bg-white p-6 rounded shadow">
        <h1 className="text-2xl font-bold mb-4">Print Test</h1>
        <p>If THIS prints, v3 API is correctly configured.</p>
      </div>
      <button
        onClick={handlePrint}
        className="mt-4 bg-blue-600 text-white px-4 py-2 rounded"
      >
        Print This
      </button>
    </div>
  );
}
